import styles from "./icon.module.scss";
import classnames from "classnames";
import Base from "@mui/material/Icon";
import Social from "./assets/Social";
import Books from "./assets/Books";

export const Icon = ({
  children,
  className,
  color,
  name: iconName,
  ...props
}) => {
  if ((!iconName && !props.svg) || props.hidden) return null;
  else if (iconName === "books") return <Books />;
  else if (props.svg) {
    return (
      <Social
        alt={props.svg}
        height={24}
        loading="lazy"
        src={`/icons/${props.svg}.svg`}
        svg={props.svg}
        width={24}
      />
    );
  }

  return (
    <Base
      className={classnames(
        styles.icon,
        {
          [styles.hidden]: props.hidden || !iconName,
          [styles.disabled]: props.disabled,
          [styles.clickeable]: props.onClick,
          [styles[color]]: color,
        },
        className
      )}
      component="i"
      {...props}
    >
      {iconName}
    </Base>
  );
};
